export const otaConnectWizard = {
  google: {
    lead: "Zuerst prüfen wir, ob die Daten Ihrer Unterkunft vollständig sind: Google hat kein Extranet und zeigt nur das an, was wir übermitteln.",
    goConnect: "In Channex fortfahren",
    nextIsChannex: "Der letzte Schritt, die Auswahl der Zimmer und Raten, die Google sieht, erfolgt im Channex-Bildschirm, der als Nächstes geöffnet wird.",
    typeLabel: "Um welche Art von Unterkunft handelt es sich?",
    hotel: "Hotel",
    hotelHint: "Mit mehreren Zimmern",
    vr: "Ferienunterkunft",
    vrHint: "Ein ganzes Haus oder Apartment",
    checking: "Daten der Unterkunft werden geprüft…",
    ready: "Alles bereit: Google kann die Unterkunft veröffentlichen.",
    missing: "1 Angabe fehlt noch vor dem Verbinden | {count} Angaben fehlen noch vor dem Verbinden",
    canFix: "Einiges davon ist bereits gespeichert und wir können es für Sie hochladen.",
    prepare: "Inserat vorbereiten",
    prepareFailed: "Das Inserat konnte nicht vorbereitet werden.",
    checkFailed: "Das Inserat konnte nicht geprüft werden.",
    cancelLabel: "Stornierungsbedingungen",
    cancelFree: "Kostenlose Stornierung",
    cancelNon: "Nicht erstattbar",
    bedrooms: "Schlafzimmer",
    beds: "Betten",
    bathrooms: "Badezimmer",
  },
  common: {
    close: "Schließen",
  },
  intro: {
    imageAlt: "Bevor Sie Booking verbinden, beachten Sie Folgendes",
    continue: "Verstanden, weiter",
  },
  header: {
    edit: "Bearbeiten",
    connect: "Verbinden",
    guidedStep: "Geführte Einrichtung · Schritt {current} von {total}",
  },
  steps: {
    connection: "Verbindung",
    rooms: "Zimmer",
    rates: "Raten",
    review: "Prüfen",
    done: "Fertig",
  },
  fields: {
    hotel_id: { label: "Hotel-ID", hint: "Sie finden sie im Extranet Ihrer OTA oben rechts." },
    hotel_code: { label: "Hotelcode", hint: "Die Kennung Ihrer Unterkunft bei der OTA." },
    property_id: { label: "Unterkunfts-ID", hint: "" },
    listing_id: { label: "Inserats-ID", hint: "" },
    property_code: { label: "Unterkunftscode", hint: "" },
    username: { label: "Benutzername", hint: "Ihr Benutzername für die Anmeldung im Extranet der OTA." },
    user: { label: "Benutzername", hint: "Ihr Benutzername für die Anmeldung im Extranet der OTA." },
    password: { label: "Passwort", hint: "Ihr Passwort für das Extranet der OTA." },
    api_key: { label: "API-Schlüssel", hint: "Die OTA stellt ihn Ihnen bereit." },
    agent_id: { label: "Agent-ID", hint: "" },
  },
  step0: {
    lead: "Fügen Sie die Kennung Ihrer Unterkunft beim Kanal ein. Wir prüfen sie sofort.",
    loadingChannel: "Anforderungen des Kanals werden geladen…",
    notAvailable: "Dieser Kanal ist über die geführte API noch nicht verfügbar.",
    oauthText: "{name} verbindet sich über eine sichere Anmeldung mit Ihrem Konto. Wenn Sie klicken, öffnen wir {name} in einem anderen Tab, damit Sie die Verbindung freigeben können; nach Ihrer Rückkehr erscheint sie in Ihren Kanälen.",
    oauthConnect: "Mit {name} verbinden",
    oauthOpened: "Wir haben {name} in einem anderen Tab geöffnet. Geben Sie die Verbindung dort frei, dann erscheint sie in Ihren Kanälen.",
    currencyLabel: "Währung",
    currencyTooltip: "Der Kanal legt sie für Ihre Unterkunft fest. Sie wird beim Prüfen der Verbindung automatisch ausgefüllt und ist nicht bearbeitbar.",
    currencyPlaceholder: "Wird beim Prüfen ausgefüllt",
    currencyDetected: "Automatisch erkannt",
    currencyVerifyToDetect: "Verbindung prüfen, um sie zu erkennen",
    verified: "Geprüft",
    testConnection: "Verbindung testen",
    testOk: "Verbindung geprüft. Weiter zum Zuordnen von Zimmern und Raten.",
    testFailedDefault: "Wir konnten die Verbindung nicht prüfen. Prüfen Sie die Kennung.",
  },
  step1: {
    leadAirbnb: "Ordnen Sie jedem Airbnb-Inserat eine Ihrer Einheiten zu.",
    leadOther: "Ordnen Sie jedem {channel}-Zimmer eine Einheit Ihres Inserats zu.",
    listingChip: "Inserat: {name}",
    noLimitChip: "Keine Begrenzung für Konten oder Unterkünfte",
    loadingRooms: "Zimmer des Kanals werden geladen…",
    noRooms: "Keine Zimmer zum Zuordnen gefunden.",
    dupUnitWarning: "«{unit}» ist mehr als einem {channel}-Zimmer zugeordnet. Jedes Kanalzimmer muss auf ein anderes Ihrer Zimmer gehen: So gespeichert würde {channel} alle zum selben Preis verkaufen. Korrigieren Sie das unten, bevor Sie fortfahren.",
    searchPlaceholder: "Suchen…",
    noRoomMatch: "Kein Zimmer passt zu «{query}».",
    copied: "Kopiert",
    copyId: "ID kopieren: {id}",
    rateCountMeta: "{channel} · {count} Rate(n)",
    edit: "Bearbeiten",
    disconnect: "Trennen",
    unitSearchPlaceholder: "Ihre Einheit oder Ihr Inserat suchen…",
    noMatch: "Keine Treffer",
    cancel: "Abbrechen",
  },
  step2: {
    lead: "Die Hauptrate jedes Zimmers wird automatisch aus Ihrer {channel}-Rate übernommen. Hat ein Zimmer mehrere Raten, legen Sie fest, wie viel % mehr (oder weniger) Sie für jede berechnen.",
    crossedFixed: "Eine Rate wurde einem anderen Zimmer zugeordnet, wodurch {channel} zum falschen Preis verkaufen würde. Die eigene Rate jedes Zimmers wurde wiederhergestellt: Prüfen Sie sie, bevor Sie fortfahren. | {count} Raten wurden einem anderen Zimmer zugeordnet, wodurch {channel} zum falschen Preis verkaufen würde. Die eigene Rate jedes Zimmers wurde wiederhergestellt: Prüfen Sie sie, bevor Sie fortfahren.",
    noRates: "Keine Raten zum Zuordnen gefunden.",
    yourPct: "Ihr % für dieses Zimmer",
    auto: "Automatisch",
    changePct: "% ändern",
    multiRateAlert: "Dieses Zimmer hat mehrere Raten. Legen Sie fest, wie viel Prozent mehr (oder weniger) Sie Ihren Gästen für jede berechnen, wenn sie über {channel} buchen.",
    minStayOnApply: "Wird mit „Anwenden“ gespeichert.",
    minStayMissing: "Kein eigener Mindestaufenthalt: {channel} verkauft sie mit dem Minimum der Hauptrate",
    setMinStay: "Mindestaufenthalt festlegen",
    nights: "{n} Nacht | {n} Nächte",
    minNights: "mind. {n} Nacht | mind. {n} Nächte",
    minInherited: "Min. der Hauptrate",
    ownPlanSummary: "eigener Preis und eigenes Minimum",
    minStayNotDerived: "Der Mindestaufenthalt ({nights}) wurde nicht gesetzt: „{rate}“ ist eine Hauptrate und nutzt ihren eigenen Mindestaufenthalt. Damit {channel} für diese Rate mindestens {nights} verlangt, wende einen Prozentsatz an, statt sie auszuwählen.",
  },
  step3: {
    lead: "Das verbinden wir bei {channel}. Prüfen Sie es und klicken Sie auf Verbinden.",
    channelCurrency: "Währung des Kanals:",
    chargesNote: "Check-in/out und Gebühren (Reinigung usw.) werden aus den Einstellungen Ihrer Unterkunft übernommen.",
  },
  done: {
    titleConnected: "{name} verbunden!",
    titleUpdated: "{name} aktualisiert!",
    subActive: "Der Kanal ist aktiv: Wir synchronisieren bereits Preise und Verfügbarkeit.",
    subPaused: "Der Kanal ist verbunden, aber pausiert. Aktivieren Sie ihn, um Preise und Verfügbarkeit zu synchronisieren.",
    subUpdated: "Die Zuordnung des Kanals wurde erfolgreich aktualisiert.",
    notificationSent: "Benachrichtigung gesendet",
    syncing: "Wird synchronisiert…",
    paused: "Pausiert",
    activateTitle: "Kanal aktivieren",
    activateDesc: "Startet die Übermittlung von Preisen und Verfügbarkeit an {channel}.",
    activateBtn: "Kanal aktivieren",
    activated: "Aktiviert",
    loadReservationsTitle: "Künftige Buchungen importieren",
    loadReservationsDesc: "Holt die Buchungen, die Sie bereits bei {channel} haben, nach WACheckin.",
    imported: "Importiert",
    extract: "Importieren",
  },
  rates: {
    mainRate: "Hauptrate",
    standardRate: "Standardrate",
  },
  rooms: {
    listingFallback: "Inserat {id}",
    unitFallback: "Einheit",
  },
  buttons: {
    back: "Zurück",
    saveChanges: "Änderungen speichern",
    connect: "Verbinden",
    finish: "Fertigstellen",
    continue: "Weiter",
  },
  errors: {
    dupUnit: "Die Einheit «{unit}» ist mehr als einem {channel}-Zimmer zugeordnet. Jedes Zimmer muss auf eine andere Einheit gehen.",
    crossedBlocked: "Es gibt eine Rate, die einem anderen Zimmer zugeordnet ist ({list}). Gehen Sie zum Schritt Raten zurück und wählen Sie für jedes Zimmer seine eigene Rate: So gespeichert würde {channel} zum falschen Preis verkaufen. | Es gibt {count} Raten, die einem anderen Zimmer zugeordnet sind ({list}). Gehen Sie zum Schritt Raten zurück und wählen Sie für jedes Zimmer seine eigene Rate: So gespeichert würde {channel} zum falschen Preis verkaufen.",
    dupRate: "Die Rate «{rate}» ist mehr als einem {channel}-Zimmer zugeordnet ({rooms}). Jedes Zimmer muss seine eigene Rate haben: So gespeichert würden sie zum selben Preis verkauft.",
    roomJoiner: " und ",
    dupRateFallback: "eine Rate",
    dupUnitFallback: "diese Einheit",
    needRate: "Ordnen Sie mindestens eine Rate zu, bevor Sie verbinden.",
    updateFailed: "Die Verbindung konnte nicht aktualisiert werden.",
    createFailed: "Die Verbindung konnte nicht erstellt werden.",
    unmapFailed: "Das Inserat konnte nicht getrennt werden.",
    needAirbnbMap: "Ordnen Sie mindestens ein Inserat einer Einheit zu.",
    unitNoChannexRate: "Die Einheit \"{unit}\" hat keine Rate mit einer Channex-ID.",
    airbnbSaveFailed: "Die Airbnb-Zuordnungen konnten nicht gespeichert werden.",
    actionFailed: "Die Aktion konnte nicht ausgeführt werden.",
    oauthLinkFailed: "Der Verbindungslink konnte nicht erzeugt werden.",
    testFailed: "Fehler beim Testen der Verbindung.",
    testNoVerify: "Dieser Kanal erfordert keine vorherige Prüfung.",
    rateCreateFailedNeedStandard: "Die Rate konnte nicht erstellt werden. Prüfen Sie, ob die Einheit eine Standardrate hat.",
    rateCreateFailed: "Die Rate konnte nicht erstellt werden.",
    minStaySaveFailed: "„{rate}“ wurde ausgewählt, aber ihr Mindestaufenthalt ({nights}) konnte nicht gespeichert werden: Es bleibt der bisherige.",
  },
};
